var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from './utils/axios';
import { convertDateToYearMonth, initSearch } from './dashboard';
import { nameGeolocalisation } from './utils/format';
import { dateEndOfTrimestre, dateEndOfWeek, dateStartOfTrimestre, dateStartOfWeek, formatDate } from './utils/utils';
export function getVisions(UtilisateurId) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/utilisateur/visions', {
                        params: {
                            UtilisateurId: UtilisateurId,
                        },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { visions: data.visions, collaborateurs: data.collaborateurs }];
            }
        });
    });
}
export function deleteVision(UtilisateurId, IdUtilisateurVision) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete('/utilisateur/vision?IdUtilisateurVision=' +
                        IdUtilisateurVision +
                        '&UtilisateurId=' +
                        UtilisateurId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function postVision(_a) {
    var UtilisateurId = _a.UtilisateurId, ObjetId = _a.ObjetId, Objet = _a.Objet;
    return axios.post('/utilisateur/vision', {
        UtilisateurId: UtilisateurId,
        ObjetId: ObjetId,
        Objet: Objet,
    });
}
export function getUtilisateurListe() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/utilisateur/liste')];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function postUtilisateur(utilisateur) {
    return axios.post('/utilisateur/store', {
        utilisateur: utilisateur,
    });
}
export function deleteUtilisateur(UtilisateurId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete('/utilisateur/delete?UtilisateurId=' + UtilisateurId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function postUpdatePassword(OldPassword, NewPassword, NewPasswordCopy) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/change-password', { OldPassword: OldPassword, NewPassword: NewPassword, NewPasswordCopy: NewPasswordCopy })];
                case 1:
                    data = (_a.sent()).data;
                    if (data.ErrorMessage) {
                        throw new Error(data.ErrorMessage);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function usurpation(UtilisateurId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/utilisateur/usurpation?UtilisateurId=' + UtilisateurId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function clearOriginalToken() {
    localStorage.removeItem('user-' + process.env.REACT_APP_NAME);
    localStorage.removeItem('refresh-' + process.env.REACT_APP_NAME);
}
export function getOriginalToken() {
    var token = localStorage.getItem('user-' + process.env.REACT_APP_NAME);
    if (!token) {
        return null;
    }
    return token;
}
export function getOriginalUser() {
    var token = getOriginalToken();
    if (!token) {
        return { Licence: {} };
    }
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64'));
}
export function getIsMobile() {
    return window.innerWidth < 720;
}
export function login(Societe, Login, Password) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/auth', {
                            Societe: Societe,
                            Login: Login,
                            Password: Password,
                        })];
                case 1:
                    result = _a.sent();
                    if (!result || !result.data) {
                        throw new Error("Connexion impossible");
                    }
                    if (result.data.ErrorMessage) {
                        throw new Error(result.data.ErrorMessage);
                    }
                    saveToken(result.data.access_token);
                    saveRefreshToken(result.data.refresh_token);
                    window.location.reload();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1.message);
                    throw new Error(error_1.message);
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function refreshToken() {
    return __awaiter(this, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/refresh-token', {
                            refreshToken: getRefreshToken(),
                        })];
                case 1:
                    data = (_a.sent()).data;
                    saveToken(data.access_token);
                    saveRefreshToken(data.refresh_token);
                    return [2 /*return*/, data.access_token];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2.message);
                    throw new Error(error_2.message);
                case 3: return [2 /*return*/];
            }
        });
    });
}
var saveToken = function (token) {
    if (!token) {
        throw new Error('Impossible de s\'authentifier');
    }
    var userInfo = JSON.parse(Buffer.from(token.split('.')[1], 'base64'));
    if (!userInfo || !userInfo.Licence) {
        throw new Error('Token invalide');
    }
    localStorage.setItem('user-' + process.env.REACT_APP_NAME, token);
};
var saveRefreshToken = function (token) {
    localStorage.setItem('refresh-' + process.env.REACT_APP_NAME, token);
};
var getRefreshToken = function () {
    return localStorage.getItem('refresh-' + process.env.REACT_APP_NAME);
};
export var getDisplayMenuMax = function () {
    return localStorage.getItem('displayMenuMax') === 'true';
};
export function requestResetPassword(Societe, Login, Email) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/request-reset-password', {
                            Societe: Societe,
                            Login: Login,
                            Email: Email,
                        })];
                case 1:
                    result = _a.sent();
                    if (result.data.ErrorMessage) {
                        throw new Error(result.data.ErrorMessage);
                    }
                    return [2 /*return*/, true];
                case 2:
                    error_3 = _a.sent();
                    console.error(error_3.message);
                    throw new Error(error_3.message);
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function resetPassword(TokenRefreshPassword, NewPassword, NewPasswordCopy) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/reset-password', {
                            TokenRefreshPassword: TokenRefreshPassword,
                            NewPassword: NewPassword,
                            NewPasswordCopy: NewPasswordCopy
                        })];
                case 1:
                    result = _a.sent();
                    if (result.data.ErrorMessage) {
                        throw new Error(result.data.ErrorMessage);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.error(error_4.message);
                    throw new Error(error_4.message);
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getFiltres(type) {
    var defaultFiltres = {};
    try {
        var results = localStorage.getItem('filtres-' + process.env.REACT_APP_NAME + '-' + type);
        if (!results) {
            return defaultFiltres;
        }
        return JSON.parse(results);
    }
    catch (e) {
        return defaultFiltres;
    }
}
export function postUpdateFiltres(type, filtres) {
    try {
        localStorage.setItem('filtres-' + process.env.REACT_APP_NAME + '-' + type, JSON.stringify(filtres));
    }
    catch (e) {
        localStorage.removeItem('filtres-' + process.env.REACT_APP_NAME + '-' + type);
    }
}
//# sourceMappingURL=utilisateur.js.map